import { STATE } from './Booking.constants';
import { ERROR } from '../../Core.constants';

const { CANCELLED, COMPLETED, CONFIRMED, POSTPONED } = STATE;

export const L10N = {
  ACTION_ANOTHER_HOTEL: { id: 'core.action.another_hotel' },
  ACTION_BACK: { id: 'common.action.back' },
  ACTION_BACK_HOME: { id: 'common.action.back_home' },
  ACTION_BOOKING_CHANGE: { id: 'core.action.booking_change' },
  ACTION_CANCEL: { id: 'common.action.cancel' },
  ACTION_CANCEL_BOOKING: { id: 'core.action.cancel_booking' },
  ACTION_CHECK_AVAILABILITY: { id: 'core.action.check_availability' },
  ACTION_CONFIRM: { id: 'common.label.confirm' },
  ACTION_EDIT_BOOKING: { id: 'core.action.edit_booking' },
  ACTION_EDIT_BOARD: { id: 'core.action.modify_accommodation_plan' },
  ACTION_EDIT_DATE: { id: 'core.action.modify_dates' },
  ACTION_EDIT_OCCUPATION: { id: 'core.action.modify_occupation' },
  ACTION_LOAD_MORE_DATES: { id: 'core.action.load_more_dates' },
  ACTION_MORE_INFO: { id: 'common.action.more_info' },
  ACTION_NEXT: { id: 'core.action.next' },
  ACTION_POSTPONE: { id: 'core.action.postpone' },
  ACTION_PRINT: { id: 'core.action.print' },
  ACTION_RESEND_BOOKING: { id: 'core.action.resend_booking' },
  ACTION_SEARCH: { id: 'common.action.search' },
  ACTION_SEND: { id: 'common.action.send' },
  ACTION_SEND_EMAIL: { id: 'common.action.send_email' },
  ACTION_SHOW_OPTIONS: { id: 'core.action.show_options' },
  ACTION_SKIP: { id: 'core.action.skip' },
  ACTION_VIEW_HOTEL: { id: 'common.action.view_hotel' },
  ACTION_VIEW_MAP: { id: 'common.action.view_map' },

  LABEL_ACCOMMODATION_TYPE: { id: 'common.label.accommodation_type_plural' },
  LABEL_ADDRESS: { id: 'common.label.address' },
  LABEL_AGENCY: { id: 'common.label.agency' },
  LABEL_BASE_PRICE_VALUE: { id: 'common.label.base_price_value' },
  LABEL_BOOKING_EXTRAS: { id: 'core.label.booking_extras' },
  LABEL_BOOKING_INFO: { id: 'core.label.booking_info' },
  LABEL_BOOKING_SUMMARY: { id: 'core.label.booking_summary' },
  LABEL_CANCELLATION_POLICY: { id: 'common.label.cancellation_policy' },
  LABEL_CANCEL_BOOKING_TITLE: { id: 'core.label.cancel_booking_title' },
  LABEL_CES_SURVEY_COMMENT: { id: 'core.label.ces_survey_comment' },
  LABEL_CES_SURVEY_COMMENT_QUESTION: { id: 'core.label.ces_survey_comment_question' },
  LABEL_CES_SURVEY_NOT_EASY: { id: 'core.label.ces_survey_not_easy' },
  LABEL_CES_SURVEY_QUESTION: { id: 'core.label.ces_survey_question' },
  LABEL_CES_SURVEY_SCORE: { id: 'core.label.ces_survey_score' },
  LABEL_CES_SURVEY_TITLE: { id: 'core.label.ces_survey_title' },
  LABEL_CES_SURVEY_VERY_EASY: { id: 'core.label.ces_survey_very_easy' },
  LABEL_CHEAPER_PRICE: { id: 'core.label.cheaper_price' },
  LABEL_CHECKIN_TIME: { id: 'common.label.checkin_time' },
  LABEL_CHECKOUT_TIME: { id: 'common.label.checkout_time' },
  LABEL_CHECK_IN: { id: 'common.label.check_in' },
  LABEL_CHECK_OUT: { id: 'common.label.check_out' },
  LABEL_CITY: { id: 'common.label.city' },
  LABEL_COMMENTS: { id: 'common.label.comments' },
  LABEL_COMMENTS_ANOTHER_HOTEL: { id: 'core.label.comments_another_hotel' },
  LABEL_COMMENTS_CHEAPER_PRICE: { id: 'core.label.comments_cheaper_price' },
  LABEL_COMMENTS_HINT: { id: 'core.label.comments_hint' },
  LABEL_COMMENTS_OTHERS: { id: 'core.label.comments_others' },
  LABEL_COMPANY_ID: { id: 'common.label.company_id' },
  LABEL_COUNTRY: { id: 'common.label.country' },
  LABEL_CURRENT_BOARD: { id: 'core.label.current_accommodation_plan' },
  LABEL_CURRENT_BOOKING: { id: 'core.label.current_booking' },
  LABEL_CURRENT_OCCUPATION: { id: 'core.label.current_occupation' },
  LABEL_EDIT_BOOKING_TEXT: { id: 'core.label.edit_booking_text' },
  LABEL_EMAIL: { id: 'common.label.email' },
  LABEL_EMAIL_TEXT: { id: 'core.label.email_text' },
  LABEL_EXTRAS: { id: 'common.label.extras' },
  LABEL_GUEST: { id: 'common.label.guest' },
  LABEL_IDPASSPORT: { id: 'common.label.id_passport' },
  LABEL_INCLUDES_TAXES: { id: 'core.label.includes_taxes' },
  LABEL_NAME: { id: 'common.label.name' },
  LABEL_NEW_BOARD: { id: 'core.label.new_accommodation_plan' },
  LABEL_NEW_BOOKING: { id: 'core.label.new_booking' },
  LABEL_NEW_OCCUPATION: { id: 'core.label.new_occupation' },
  LABEL_NIGHT_COUNT: { id: 'common.label.night_count' },
  LABEL_NOT_TRAVEL: { id: 'core.label.not_travel' },
  LABEL_OTHERS: { id: 'common.label.others' },
  LABEL_PHONE: { id: 'common.label.phone' },
  LABEL_PREFERENCES: { id: 'common.label.preferences' },
  LABEL_PROMO_CODE: { id: 'common.label.promo_code' },
  LABEL_RATE: { id: 'common.label.rate' },
  LABEL_REQUIRED: { id: 'common.label.required' },
  LABEL_ROOM_COUNT: { id: 'common.label.room_count' },
  LABEL_ROOM_NUMBER: { id: 'core.label.room_number' },
  LABEL_SELECT_BOARD: { id: 'core.label.select_available_accommodation_plan' },
  LABEL_SELECT_ROOM_BOARD: { id: 'core.label.select_room_accommodation_plan' },
  LABEL_SELECT_ROOM: { id: 'core.label.select_room' },
  LABEL_SERVICE_ERROR: { id: 'common.label.service_error' },
  LABEL_STATEREGION: { id: 'common.label.state_region' },
  LABEL_SUBJECT_TO_AVAILABILITY: { id: 'core.label.subject_to_availability' },
  LABEL_TOTAL: { id: 'common.label.total' },
  LABEL_WHEN: { id: 'core.label.when' },
  LABEL_YOUR_RESERVATION: { id: 'core.label.your_reservation' },
  LABEL_ZIPCODE: { id: 'common.label.zip_code' },

  NOTIFICATION: {
    [CANCELLED]: { id: 'common.notification.cancelled' },
    [CONFIRMED]: { id: 'common.notification.confirmed' },
    [COMPLETED]: { id: 'common.notification.completed' },
    [POSTPONED]: { id: 'common.notification.postponed' },
  },
  NOTIFICATION_ADJUST_DIFFERENT: { id: 'core.notification.adjust_different' },
  NOTIFICATION_CANCEL_BOOKING_SUCCESS: { id: 'core.notification.cancel_booking_sucess' },
  NOTIFICATION_EDIT_BOOKING_SUCCESS: { id: 'core.notification.edit_booking_success' },
  NOTIFICATION_EDIT_BOARD_SUCCESS: { id: 'core.notification.edit_accommodation_plan_success' },
  NOTIFICATION_EDIT_DATE_SUCCESS: { id: 'core.notification.edit_date_success' },
  NOTIFICATION_EDIT_DATE_WARNING: { id: 'core.notification.edit_date_warning' },
  NOTIFICATION_EDIT_OCCUPATION_SUCCESS: { id: 'core.notification.edit_occupation_success' },
  NOTIFICATION_EDIT_PARTIAL_ROOM_SELECTION: { id: 'core.notification.edit_partial_room_selection' },
  NOTIFICATION_EMAIL_SUCCESS: { id: 'core.notification.email_success' },
  NOTIFICATION_ERROR: {
    [ERROR.NOT_AVAILABLE]: { id: 'common.notification.error_not_available' },
    [ERROR.PARAMETER_ERROR]: { id: 'common.notification.error_parameter' },
    [ERROR.UNKNOWN]: { id: 'common.notification.error_unknown' },
  },
  NOTIFICATION_PAY_LATER_PREPAY: { id: 'core.notification.pay_later_prepay' },
  NOTIFICATION_PAY_LATER_GUARANTEE: { id: 'core.notification.pay_later_guarantee' },
  NOTIFICATION_POS_ERROR: { id: 'core.notification.pos_error' },
  NOTIFICATION_POS_TITLE_ERROR: { id: 'core.notification.pos_title_error' },
  NOTIFICATION_SSL_ENCRYPTION: { id: 'common.notification.ssl_encryption' },
  NOTIFICATION_WARNING_NO_AVAILABILITY: { id: 'core.notification.warning_no_availability' },
  NOTIFICATION_WARNING_NO_OCCUPANCY_AVAILABILITY: { id: 'core.notification.warning_no_occupancy_availability' },
};
